import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { AlertService, DatasourceService } from '@app/core/services';
import { GridComponent } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { WindowState } from '@progress/kendo-angular-dialog';

import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';


@Component({
  selector: 'edit-role-permissions',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="850" title="Editar Permisos {{ (mode == 'CREATE') ? '' : '(Id: '  + rol.id + ') ' + rol.name }}" *ngIf="opened" (close)="onClose()" [(state)]="windowState">
  
    <!-- {{ rol.selected | json }} -->
    
    <div class="example-wrapper form-detail">   
    
      <kendo-grid *ngIf="rol.permissions" [data]="rol.permissions" [resizable]="true">
        <kendo-grid-column field="n" title="#" width="60" [filterable]="false">
          <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
            # {{rowIndex + 1}}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="name" title="Permiso" width="250" [style]="rightAlign" [footerStyle]="rightAlign"></kendo-grid-column>

        <!--<kendo-grid-checkbox-column width="50">
          <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
            <input type="checkbox" id="checkbox_all" kendoCheckBox [checked]="true"/>
          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <input type="checkbox" id="checkbox_permiso_{{dataItem.id}}" kendoCheckBox [checked]="false"/>
          </ng-template>
        </kendo-grid-checkbox-column>-->

        <kendo-grid-column
          *ngFor="let column of rol.actions"
          field="{{column.name}}"
          title="{{column.name}}"
          width="60" [style]="centerAlign" [footerStyle]="rightAlign" 
        >
          <!--<ng-template kendoGridHeaderTemplate let-columnIndex="columnIndex">
            <input type="checkbox" id="checkbox_accion_{{column.id}}" kendoCheckBox [checked]="false" />
            <span class="k-icon {{column.icon}}"></span>
          </ng-template>-->
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <input type="checkbox" id="checkbox_{{dataItem.id}}-{{column.id}}" kendoCheckBox *ngIf="existCheckbox(dataItem, column)" [checked]="isChecked(dataItem, column)" (click)="onCheckBoxClick($event, rowIndex, dataItem)"/>
          </ng-template>        
        </kendo-grid-column>

                  
      </kendo-grid>

    </div>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary" (click)="onSave()">Guardar</button>
    </div>

  </kendo-window>      
  `,
  styles: [`
    .pageNum {
      font-family: "DejaVu Sans", "Arial", sans-serif;
      position: absolute;
      top: 10px;
      left: 10px;
    }

    kendo-pdf-export {
      font-family: "DejaVu Sans", "Arial", sans-serif;
      font-size: 12px;
    }

    .k-textbox-container, input.k-textbox {
      width: 100%;
    }

    input[type=radio] {
      margin-top: 14px;
    }    

    .k-radio-label {
      padding-right: 10px;
      padding-left: 10px;
      padding-top: 12px;
    }
  `],
  providers: [ DatasourceService ]
})
export class EditRolePermissionsComponent {

  //Inputs

  @ViewChild(GridComponent, {static: false}) grid !: GridComponent;

  @Input() opened = false;  

  @Input() id = 0;

  //Variables

  public windowState: WindowState = 'maximized';

  protected dataItem: any;

  protected mode = 'EDIT';

  //Eventos

  @Output() cancel: EventEmitter<any> = new EventEmitter();

  @Output() save: EventEmitter<{mode:string, dataItem:any}> = new EventEmitter();    

  //Métodos

  constructor(protected service : DatasourceService, protected http: HttpClient, protected alertService: AlertService) {

  }

  public onCancel(): void {

    this.opened = false;    

  }

  public onClose(): void {

    this.opened = false;    

  }

  public rol: any = { 
    id: 0,
    name: '',
    actions: [],       
    permissions: [],
    permissions_roles: [],
    selected: []
  };

  // public create(): void {

  //     this.mode = 'CREATE';
  //     this.opened = true;
  //     // this.reset();
        
  // }
  public isChecked(permission: any, action: any) {

    let r : boolean = false;

    for (let p of this.rol.permissions_roles) {

        if(p.id_permission === permission.id && p.id_action === action.id) {
          r = true;
        }
    }

    return r;

  }

  public existCheckbox(permission: any, action: any) {

    let p : any [] = permission.id_actions.split(',');

    let found = p.find(element => element == action.id.toString());

    return (typeof found == 'undefined' ) ? false: found.length;

  }

  public edit(dataItem: any): void {

    this.mode = 'EDIT';
    this.opened = true;
    // this.maximize();

    this.rol.selected = [];

    this.rol.id = dataItem.id;
    this.rol.name = dataItem.name;

    let state_actions : State = {
      skip: 0, 
      take: 0, 
      sort: [],
      filter: {
        logic: "and",
        filters: []
      }, 
      group: []
    }

    this.service.getAll('actions', state_actions, (table, res)=>{
    
      // console.log(res.data);
      this.rol.actions = res.data;
            
    });

    let state_permissions : State = {
      skip: 0, 
      take: 0, 
      sort: [      
        {field: 'name', dir: 'asc'},
      ],
      filter: {
        logic: "and",
        filters: []
      }, 
      group: []
    }

    this.service.getAll('permissions', state_permissions, (table, res)=>{
    
      // console.log(res.data);
      this.rol.permissions = res.data;
            
    });

    
    this.permissions(dataItem.id)
      .subscribe(
          permissions => {

            this.rol.permissions_roles = permissions;

            for (let p of permissions) {
              this.addRemoveSelection(p.id_permission, p.id_action, true);
            }

          },
          error => {
              console.log(error)
              // this.loading = false;
          });
  
  }

  permissions(id_role: number) {

    let state : State = {
        // skip: 0, 
        take: 0,
        sort: [], 
        filter: {
            logic: "and",
            filters: [{
                field: 'id_role',
                operator: 'eq',
                value: id_role
            }]
        }, 
        //group: []
    }
    return this.http.post<any>(`${environment.apiUrl}/api/permissions_roles/search`, state)
        .pipe(map(res => {
            return res.data;
        }));

  }

  protected getData(): Object {

    return this.rol.selected;

  };  

  public onSave(): void {

    let data = this.getData();
    // console.log(data);

    this.service.remove_batch('permissions_roles', 'id_role', this.rol.id, null, (table, res)=>{

      // console.log(table, res)      

      let data = this.getData();

      this.service.add_batch('permissions_roles', data, null, (table, res)=>{

        // console.log(table, res)

        this.opened = false;

        this.alertService.showSuccess('Se actualizaron con éxito los permisos del rol: ' + this.rol.name);

      });

    });

  }

  onCheckBoxClick(e, rowIndex, dataItem) {
    // console.log("Event: ", e.target.id);
    // console.log("RowIndex: ", rowIndex);    
    let parts = e.target.id.split('-'); 
    let id_permission: number = dataItem.id;
    let id_action: number = parseInt(parts[1]);

    // console.log("Clic: ", dataItem.id, parts[1], e.target.checked);   
    this.addRemoveSelection(id_permission, id_action, e.target.checked);
  }

  addRemoveSelection(permission: number, action: number, checked: boolean): void {

    let found = this.rol.selected.find(x => x.id_permission === permission && x.id_action === action);
    
    if(typeof found == 'undefined'){
      this.rol.selected.push({ 
        id_permission: permission, 
        id_action: action,
        id_role: this.rol.id
      })
    }
    else {
      const index = this.rol.selected.indexOf(found, 0);
      // console.log(index);
      if (index > -1) {
        this.rol.selected.splice(index, 1)
      }
      
    }

    console.log(found, this.rol.selected);

  }  

}
